import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Register from "./pages/auth/Register";
import Login from "./pages/auth/Login";
import Dashboard from "./pages/admin/Dashboard";
import ProductDemo from "./pages/admin/ProductDemo";
import Page404 from "./pages/static/404";
import GymLanding from "./pages/admin/GymWebPage";

const App = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={Register} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/dashboard" component={Dashboard} />
        <Route exact path="/gym/:landing" component={GymLanding} />
        <Route exact path="/showcase" component={ProductDemo} />
        <Route exact path="/404" component={Page404} />
        <Route exact path="*" component={Page404} />
      </Switch>
    </BrowserRouter>
  );
};

export default App;
